module.exports = __webpack_public_path__ + "media/images/facebook-57d3f125e2df9795fe8af82fcd70dc58.svg";